module.exports = __webpack_public_path__ + "img/华中科技大学logo.5ae1406c.png";